import { FC } from 'react';
import { Stack } from '@mui/material';
import { Modal, TextField } from 'melp-design/components';
import { Controller, useForm } from 'react-hook-form-latest';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'store/modal';

interface Values {
  name: string;
}

const INITIAL_VALUES: Values = {
  name: '',
};

interface Props extends ModalProps {
  initialName?: string;
  closeModal: (
    param?: { action: 'CLOSE' } | { action: 'CONFIRM'; name: string },
  ) => void;
}

export const NewNameModal: FC<Props> = ({ closeModal, initialName = '' }) => {
  const { t } = useTranslation();

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: INITIAL_VALUES,
    values: { name: initialName },
  });

  return (
    <form
      onSubmit={handleSubmit(({ name }) => {
        closeModal({ action: 'CONFIRM', name });
      })}
    >
      <Modal.Content
        title={t('news.create_news')}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal({ action: 'CLOSE' }),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.confirm'),
            type: 'submit',
          },
        ]}
      >
        <Stack spacing={2}>
          <Controller
            name="name"
            control={control}
            render={({ field: { name, value, onChange, ref } }) => {
              return (
                <TextField
                  label={t('common.systemName')}
                  name={name}
                  value={value}
                  onChange={onChange}
                  required
                  ref={ref}
                />
              );
            }}
          />
        </Stack>
      </Modal.Content>
    </form>
  );
};
